import React, { useEffect, useState } from "react";
import ImageUploading from "react-images-uploading";
import { useNavigation, useAuth } from "react-uicomp";
import { useForm, Controller } from "react-hook-form";
import { AiFillCloseCircle } from "react-icons/ai";
import Select from "react-select";
// MATERIAL
import { Button } from "@material-ui/core";

// DRAFT
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

// ACTIONS
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  postTeamMemberAction,
  getResearchProgramAction,
} from "../../../actions/Actions";

// HOCS
import CompWrapper from "../../hocs/CompWrapper.hoc";
import ActivityIndicator from "../../hocs/ActivityIndicator.hoc";

// COMMON
import {
  InputField,
  TextAreaField,
} from "../../common/inputField/InputField.common";

// HELPERS
import { validator, isValid } from "../../../utils/Validator.util";

const options = [
  {
    valueEng: "The Directors",
    valueNep: "निर्देशकहरु",
    label: "The Directors",
  },
  {
    valueEng: "Research Team",
    valueNep: "अन्वेषकहरू",
    label: "Research Team",
  },
  {
    valueEng: "UK Researcher Advisors",
    valueNep: "बेलायतका अन्वेषक सल्लाहकारहरू",
    label: "UK Researcher Advisors",
  },
  {
    valueEng: "Collaborators In Nepal",
    valueNep: "नेपालका सहयोगीहरू",
    label: "Collaborators In Nepal",
  },
  {
    valueEng: "International Collaborators",
    valueNep: "अन्तर्राष्ट्रिय सहयोगीहरू",
    label: "International Collaborators",
  },
];

const selectStyles = {
  control: (styles) => ({
    ...styles,
    borderRadius: 4,
    borderColor: "#E1E1E1",
    backgroundColor: "#F8F8F8",
    "&:hover": { borderColor: "#0284A4" },
  }),
  option: (styles, { isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#0284A4" : "#fff",
      "&:hover": { backgroundColor: "#e9e9e9" },
    };
  },
};

const AddTeamMemberPage = (props) => {
  const { navigation } = useNavigation();
  const { toast } = useAuth();
  const { navigate, routes } = navigation;
  const {
    postTeamMemberAction,
    teamMember,
    getResearchProgramAction,
    researchProgram,
  } = props;
  const { addLoader } = teamMember;

  const { listResearchPorgram } = researchProgram;

  const { handleSubmit, register, control } = useForm();
  // const [engEditorState, setEngEditorState] = useState(
  //   EditorState.createEmpty(),
  // );
  // const [nepEditorState, setNepEditorState] = useState(
  //   EditorState.createEmpty(),
  // );

  const [image, setImage] = useState([]);
  const [imageError, setImageError] = useState(false);
  // const [thumbnailImage, setThumbnail] = useState([]);
  // const [thumbnailError, setThumbnailError] = useState(false);
  // const [eventDate, setEventDate] = useState(new Date());

  const onChange = (imageList) => {
    setImageError(false);
    setImage(imageList);
  };

  const [researchProgramOption, setResearchProgramOption] = useState([]);
  const [selectedResearchProgram, setSelectedResearchProgram] = useState([]);

  const handleResearchProgram = (selectedOptions) => {
    setSelectedResearchProgram(selectedOptions);
  };

  useEffect(() => {
    const remappedResearchProgramList = listResearchPorgram?.map(
      (item, index) => {
        return {
          id: item.id,
          label: item.name.en,
          value: item.name.en,
        };
      },
    );
    setResearchProgramOption(remappedResearchProgramList);
  }, [listResearchPorgram]);

  useEffect(() => {
    getResearchProgramAction(1);
  }, [getResearchProgramAction]);

  // const onChangeThumbnail = (imageList) => {
  //   setThumbnailError(false);
  //   setThumbnail(imageList);
  // };

  // const onEngChangeText = (editorState) => {
  //   setEngEditorState(editorState);
  // };

  // const onNepChangeText = (editorState) => {
  //   setNepEditorState(editorState);
  // };

  const onSubmit = (data) => {
    const catchedErros = {};
    const validate = validator(catchedErros);

    // VALIDATION
    validate("imageFile", image?.length === 0, () => {
      toast({ message: "Image is Required", type: "error" });
    });

    validate(
      "selectedResearchProgram",
      selectedResearchProgram?.length === 0,
      () => {
        toast({
          message: "Please Choose at least one research program",
          type: "error",
        });
      },
    );

    if (!isValid(catchedErros)) {
      console.error(catchedErros);
      return;
    }

    const description = {
      name: {
        en: data.nameEng,
        np: data.nameEng,
      },
      designation: {
        en: data.designationEng,
        np: data.designationNep,
      },
      address: {
        en: data.addressEng,
        np: data.addressNep,
      },

      role: {
        en: data.role.valueEng,
        np: data.role.valueNep,
      },
    };

    const remappedSelectedResearchProgram = selectedResearchProgram?.map(
      (item, index) => {
        return item.id;
      },
    );

    const formdata = new FormData();

    formdata.append("name", data.nameEng);
    formdata.append("designation", data.designationEng);
    formdata.append("address", data.addressEng);
    formdata.append("role", data.role.valueEng);
    formdata.append("description", JSON.stringify(description));
    formdata.append(
      "bio",
      JSON.stringify({
        en: data.bioEng,
        np: data.bioNep,
      }),
    );
    formdata.append("type", "team");

    formdata.append(
      "researchProgramId",
      JSON.stringify(remappedSelectedResearchProgram),
    );

    formdata.append("imageFile", image[0].file);

    postTeamMemberAction(formdata, goBackHandler, toast);
  };

  const goBackHandler = () => {
    navigate(routes["Team Member"].path);
  };

  return (
    <CompWrapper>
      <div className="addnews-container">
        <div className="addnews">
          <form className="addnews-form" onSubmit={handleSubmit(onSubmit)}>
            <div className="addnews-form-input">
              <div className="addnews-form-input-label">Name</div>

              <InputField
                name="nameEng"
                placeholder="Name"
                innerRef={register({ required: true })}
              />
            </div>

            <div className="addnews-form-input">
              <div className="addnews-form-input-label">Designation</div>

              <InputField
                name="designationEng"
                placeholder="Designation"
                innerRef={register({ required: true })}
              />
            </div>

            <div className="addnews-form-input">
              <div className="addnews-form-input-label">Role/भूमिका</div>

              {/* <InputField
                name="roleEng"
                placeholder="Role"
                innerRef={register({ required: true })}
              /> */}

              <Controller
                as={
                  <Select
                    isClearable={true}
                    // getOptionLabel={(option) => `${option.name}`}
                    getOptionValue={(option) => `${option.valueEng}`}
                    options={options}
                    styles={selectStyles}
                    placeholder="Select Role"
                  />
                }
                name="role"
                control={control}
                defaultValue=""
                rules={{
                  required: { value: true, message: "This field is required" },
                }}
              />
            </div>

            <div className="addnews-form-input">
              <div className="addnews-form-input-label">Address</div>

              <InputField
                name="addressEng"
                placeholder="Address"
                innerRef={register({ required: true })}
              />
            </div>

            <div className="addnews-form-input">
              <div className="addnews-form-input-label">Bio</div>

              <TextAreaField
                name="bioEng"
                placeholder="Your Bio ..."
                innerRef={register({ required: true })}
              />
            </div>

            <div className="addnews-form-input">
              <div className="addnews-form-input-label">नाम</div>

              <InputField
                name="nameNep"
                placeholder="नाम"
                innerRef={register({ required: true })}
              />
            </div>

            <div className="addnews-form-input">
              <div className="addnews-form-input-label">पद नाम</div>

              <InputField
                name="designationNep"
                placeholder="पद नाम"
                innerRef={register({ required: true })}
              />
            </div>

            {/* <div className="addnews-form-input">
              <div className="addnews-form-input-label">भूमिका</div>

              <InputField
                name="roleNep"
                placeholder="भूमिका"
                innerRef={register({ required: true })}
              />
            </div> */}

            <div className="addnews-form-input">
              <div className="addnews-form-input-label">ठेगाना</div>

              <InputField
                name="addressNep"
                placeholder="ठेगाना"
                innerRef={register({ required: true })}
              />
            </div>

            <div className="addnews-form-input">
              <div className="addnews-form-input-label">बायो</div>

              <TextAreaField
                name="bioNep"
                innerRef={register({ required: true })}
                placeholder="तपाईको बायो..."
              />
            </div>

            <ImageUploading value={image} onChange={onChange} multiple={false}>
              {({ imageList, onImageUpload, onImageRemove }) => (
                <div className="upload__image-wrapper">
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat( auto-fill, minmax(200px, 1fr) )",
                      columnGap: 10,
                    }}>
                    {imageList.map((image, index) => (
                      <div
                        key={index}
                        style={{
                          position: "relative",
                          width: 200,
                          height: 200,
                          overflow: "hidden",
                        }}>
                        <img
                          src={image.dataURL}
                          alt=""
                          style={{
                            width: "100%",
                            objectFit: "cover",
                            overflow: "hidden",
                          }}
                        />
                        <AiFillCloseCircle
                          onClick={() => onImageRemove(index)}
                          style={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            height: 20,
                            width: 20,
                            color: "red",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    ))}
                  </div>
                  <Button
                    className="fixedwidth"
                    onClick={onImageUpload}
                    variant="contained"
                    color="primary">
                    {image?.length > 0 ? "Change Image" : "Upload image"}
                  </Button>
                  {imageError && <div>Image Required</div>}
                </div>
              )}
            </ImageUploading>

            <div className="addnews-form-input">
              <div className="addnews-form-input-label">Research Program</div>
              <Select
                name="addNewsPage"
                isMulti
                options={researchProgramOption}
                value={selectedResearchProgram}
                onChange={handleResearchProgram}
                placeholder="Select Research Program"
              />
            </div>

            <ActivityIndicator animating={addLoader}>
              <Button
                className="fixedwidth"
                variant="contained"
                color="primary"
                type="submit">
                Submit
              </Button>
            </ActivityIndicator>
          </form>
        </div>
      </div>
    </CompWrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    teamMember: state.teamMember,
    researchProgram: state.researchProgram,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      postTeamMemberAction,
      getResearchProgramAction,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(AddTeamMemberPage);

// The Directors
// Research Team
// UK Researcher Advisors
// Collaborators In Nepal
// International Collaborators

// eslint-disable-next-line no-lone-blocks
{
  /* <Controller
as={<Select
  isClearable={true}
  getOptionLabel={option =>
    `${option.name}`
  }
  getOptionValue={option => `${option.code}`}
  options={marital?.options}
  placeholder="Select Status"
/>}
name="maritalStatus"
control={control}
defaultValue=''
rules={{ required: { value: true, message: "This field is required" } }}
/>  */
}
